module.exports = __webpack_public_path__ + "img/cxqd.b5af8b4f.jpg";